import { render } from "./BlogSearch.vue?vue&type=template&id=5b68a019&scoped=true"
import script from "./BlogSearch.vue?vue&type=script&lang=js"
export * from "./BlogSearch.vue?vue&type=script&lang=js"

import "./BlogSearch.vue?vue&type=style&index=0&id=5b68a019&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b68a019"]])

export default __exports__